/**
 * 风险治理相关字典
 */
import Dict from '@/utils/dict-utils'
import { purchaseTypeDict } from '@/dictionary/project/common'
import { efficientBidInviteWayShowDict } from '@/dictionary/project/bid'

/**
 * 采购方式
 */
export const riskPurchaseMethodDict = new Dict({
  PUBLIC_BIDDING: {
    ...efficientBidInviteWayShowDict.PUBLIC_BIDDING,
    label: `招标-${efficientBidInviteWayShowDict.PUBLIC_BIDDING.label}`,
    purchaseType: purchaseTypeDict.BIDDING.value
  },
  INVITE_BIDDING: {
    ...efficientBidInviteWayShowDict.INVITE_BIDDING,
    label: `招标-${efficientBidInviteWayShowDict.INVITE_BIDDING.label}`,
    purchaseType: purchaseTypeDict.BIDDING.value
  },
  COMPETITIVE_CONSULT: {
    ...efficientBidInviteWayShowDict.COMPETITIVE_CONSULT,
    label: `招标-${efficientBidInviteWayShowDict.COMPETITIVE_CONSULT.label}`,
    purchaseType: purchaseTypeDict.BIDDING.value
  },
  COMPETITIVE_NEGOTIATION: {
    ...efficientBidInviteWayShowDict.COMPETITIVE_NEGOTIATION,
    label: `招标-${efficientBidInviteWayShowDict.COMPETITIVE_NEGOTIATION.label}`,
    purchaseType: purchaseTypeDict.BIDDING.value
  },
  INQUIRY: {
    ...efficientBidInviteWayShowDict.INQUIRY,
    label: `招标-${efficientBidInviteWayShowDict.INQUIRY.label}`,
    purchaseType: purchaseTypeDict.BIDDING.value
  },
  SINGLE_SOURCE: {
    ...efficientBidInviteWayShowDict.SINGLE_SOURCE,
    label: `招标-${efficientBidInviteWayShowDict.SINGLE_SOURCE.label}`,
    purchaseType: purchaseTypeDict.BIDDING.value
  },
  DIRECT: {
    ...efficientBidInviteWayShowDict.DIRECT,
    label: '询比',
    purchaseType: purchaseTypeDict.INQUIRY.value
  }
})

/**
 * 风险点
 */
export const riskPointsDict = new Dict({
  1: {
    label: '招标公告期过短',
    value: 'noticeOpenDaysShort',
    getContent(orderName, riskItems = []) {
      return `【${orderName || ''}】招标公告期为${riskItems?.[0]?.values?.[0]
        ?.actualValue || 0}天，因此该采购单位命中风险`
    }
  },
  2: {
    label: '录入招标结果时间过长',
    value: 'inputResultdaysLong',
    getContent(orderName, riskItems = []) {
      return `【${orderName || ''}】招标结果录入时长为${riskItems?.[0]
        ?.values?.[0]?.actualValue || 0}天，因此该采购单位命中风险`
    }
  },
  3: {
    label: '项目流标次数过多',
    value: 'closeTooFrequently',
    getContent(orderName, riskItems = []) {
      return `【${orderName || ''}】流标次数为${riskItems?.[0]?.values?.[0]
        ?.actualValue || 0}，因此该采购单位命中风险`
    }
  },
  4: {
    label: '报价畸高畸低',
    value: 'supplierOfferDiff',
    getContent(orderName, riskItems = []) {
      let tempStr = ''
      riskItems.forEach(item => {
        const values = (item.values || [])
          .map(x => `${x.actualName}为${(Number(x.actualValue || 0) * 100).toFixed(2)}%`)
          .join('，')
        const text = `【${item.triggerValue || ''}】${values}`
        tempStr += `${text};`
      })
      return `【${orderName || ''}】中，${tempStr}因此上述供应商命中风险`
    }
  },
  5: {
    label: '投标报价呈现规律性',
    value: 'supplierOfferRegular',
    getContent(orderName, riskItems = []) {
      let tempStr = ''
      riskItems.forEach(item => {
        const text = `【${item.triggerValue || ''}】报价为${item?.values?.[0]
          ?.actualValue || 0}`
        tempStr += `${text}，`
      })

      return `【${orderName ||
        ''}】中，${tempStr}呈现等差或等比数列，因此上述供应商命中风险`
    }
  },
  6: {
    label: '项目弃标供应商比例过高',
    value: 'abandonedSupplierHighRatio',
    getContent(orderName, riskItems = []) {
      const percent =
        Number(riskItems?.[0]?.values?.[0]?.actualValue || 0) * 100
      return `【${orderName || ''}】中，${riskItems?.length ||
        0}家供应商弃标，占比为${percent.toFixed(2)}%，因此上述供应商命中风险`
    }
  },
  // 7: { label: '投标单位开标所用IP存在重合', value: 'openIpSame' },
  8: {
    label: '投标单位所用设备MAC地址存在重合',
    value: 'macAddressSame',
    getContent(orderName, riskItems = []) {
      return `【${orderName || ''}】中，${riskItems?.length ||
        0}家供应商报名制作标书所用MAC均为${riskItems?.[0]?.values?.[0]
        ?.actualValue || ''}，因此上述供应商命中风险`
    }
  },
  9: {
    label: '评分畸高畸低',
    value: 'expertScoreDiff',
    getContent(orderName, riskItems = []) {
      let tempStr = ''
      riskItems.forEach(item => {
        const text = `【${item.triggerValue || ''}】专家${item?.values?.[0]
          ?.actualName || ''}为${(
          Number(item?.values?.[0]?.actualValue || 0) * 100
        ).toFixed(2)}%`

        tempStr += `${text}，`
      })
      return `【${orderName || ''}】中，${tempStr}因此上述专家命中风险`
    }
  },
  10: {
    label: '评分呈现规律性',
    value: 'expertScoreRegular',
    getContent(orderName, riskItems = []) {
      let tempStr = ''
      riskItems.forEach(item => {
        const text = `【${item.triggerValue || ''}】评审总分为${item
          ?.values?.[0]?.actualValue || 0}`
        tempStr += `${text}，`
      })

      return `【${orderName ||
        ''}】中，${tempStr}呈现等差数列或等比数列，因此上述专家命中风险`
    }
  },
  11: {
    label: '单个项目重评次数过多',
    value: 'reviewTimesTooMuch',
    getContent(orderName, riskItems = []) {
      return `【${orderName || ''}】中，重评次数为${riskItems?.[0]?.values?.[0]
        ?.actualValue || 0}，因此该采购单位命中该风险`
    }
  },
  12: {
    label: '中标价与预算价差异过大',
    value: 'biddingAndBudgetPriceDifferWidely',
    getContent(orderName, riskItems = []) {
      let tempStr = ''
      riskItems.forEach(item => {
        const text = `【${item.triggerValue || ''}】${item?.values?.[0]
          ?.actualName || ''}为${(
          Number(item?.values?.[0]?.actualValue || 0) * 100
        ).toFixed(2)}%`
        tempStr += `${text}，`
      })
      return `【${orderName || ''}】中，${tempStr}因此该供应商命中风险`
    }
  },
  13: {
    label: '投标单位保证金来源账户存在重合',
    value: 'sourceAccountsOverlap',
    getContent(orderName, riskItems = []) {
      const tempStr = `${riskItems
        .map(item => `【${item.triggerValue}】`)
        .join('、')}缴纳保证金所用账户均为${riskItems?.[0]?.values?.[0]
        ?.actualValue || ''}`
      return `【${orderName || ''}】中，${tempStr}，因此上述供应商命中风险`
    }
  },
  14: {
    label: '投标单位报名所用IP存在重合',
    value: 'signupIpSame',
    getContent(orderName, riskItems = []) {
      const tempStr = `${riskItems
        .map(item => `【${item.triggerValue}】`)
        .join('、')}报名所用IP均为${riskItems?.[0]?.values?.[0]?.actualValue ||
        ''}`

      return `【${orderName || ''}】中，${tempStr}，因此上述供应商命中风险`
    }
  },
  27: {
    label: '有效参与项目投标单位数量未达标',
    value: 'effectivelyParticipateProjectBidders',
    getContent(orderName, riskItems = [], criticalValue) {
      return `【${orderName ||
        ''}】项目，有效参与项目投标单位数量为${riskItems?.[0]?.values?.[0]
        ?.actualValue || 0}，不足${criticalValue ||
        0}家，因此该采购单位命中风险`
    }
  }
})

/**
 * 风险等级
 */
export const riskLevelDict = new Dict({
  HIGH: { label: '高', value: 1, type: 'danger' },
  MEDIUM: { label: '中', value: 2, type: 'warning' },
  LOW: { label: '低', value: 3, type: 'success' }
})

/**
 * 风险类型
 */
export const riskTypeDict = new Dict({
  PROGRAM: { label: '程序风险', value: 1 },
  BID: { label: '投标风险', value: 2 },
  QUOTE: { label: '报价风险', value: 3 },
  EVALUATION: { label: '评标风险', value: 4 },
  RELATED: { label: '关联风险', value: 5 }
})

/**
 * 招标环节
 */
export const riskNodeDict = new Dict({
  APPLY: { label: '报名环节', value: 1 },
  CANDIDATE: { label: '报价环节', value: 4 },
  OPENBID: { label: '评标环节', value: 3 },
  RESULT: { label: '成交环节', value: 5 }
})

/**
 * 逻辑判断
 */
export const riskJudgeTypeDict = new Dict({
  1: { label: '>', value: 1 },
  2: { label: '<', value: 2 },
  3: { label: '=', value: 3 },
  4: { label: '≥', value: 4 },
  5: { label: '≤', value: 5 }
})

/**
 * 阈值类型
 */
export const riskCriticalTypeDict = new Dict({
  NUMBER: { label: '数值', value: 1 },
  BOOLEAN: { label: '布尔', value: 2 },
  PERCENT: { label: '百分比', value: 3 }
})

/**
 * 是否启用
 */
export const riskIsEnableDict = new Dict({
  DELETED: { label: '已删除', value: -1 },
  EDITING: { label: '编辑中', value: 0 },
  OPENED: { label: '已启用', value: 1 },
  DISABLED: { label: '已禁用', value: 2 }
})

/**
 * 是否
 */
export const riskWhetherDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})

/**
 * 风险处理状态
 */
export const riskHandleStatusDict = new Dict({
  PENDING: { label: '待处理', value: 1, type: 'warning', permission: ['edit'] },
  CONFIRM: {
    label: '已处理',
    value: 2,
    type: 'success',
    permission: ['detail'],
    radioLabel: '是',
    alias: '风险确认'
  },
  SECURE: {
    label: '已处理',
    value: 3,
    type: 'success',
    permission: ['detail'],
    radioLabel: '否',
    alias: '风险解除'
  }
})

/**
 * 通知条件
 */
export const riskNoticeConditionsDict = new Dict({
  1: { label: '发生高风险', value: 1 },
  2: { label: '发生中风险及以上', value: 2 },
  3: { label: '发生低风险及以上', value: 3 }
})

/**
 * 任务状态
 */
export const riskTaskStatusDict = new Dict({
  PEND_RECEIVE: {
    label: '未接收',
    value: 1,
    type: 'warning',
    permission: ['detail', 'receive'],
    desc: '已生成督办任务，但未接收'
  },
  PEND_HANDLE: {
    label: '待处理',
    value: 2,
    type: 'primary',
    permission: ['detail', 'handle'],
    desc: '已接收督办任务，但完成未处理'
  },
  HANDLED: {
    label: '已处理',
    value: 3,
    type: 'success',
    permission: ['detail'],
    desc: '已处理完成'
  },
  OVERDUE: {
    label: '已逾期',
    value: -1,
    type: 'danger',
    permission: ['detail'],
    desc: '超过处理截止时间但未处理（大于处理截止时间）'
  }
})

/**
 * 是否催办
 */
export const riskWhetherUrgingDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

/**
 * 是否确认风险
 */
export const riskWhetherConfirmRiskDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})

/**
 * 是否流标
 */
export const riskWhetherAbandonDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})

/**
 * 是否已读
 */
export const riskWhetherReadDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})